import { gql } from '@apollo/client';

import type {
  GetVendors,
  GetVendorsVariables,
} from './__generated__/GetVendors';

import type {
  GetVendorsWithInvoicePreview,
  GetVendorsWithInvoicePreviewVariables,
} from './__generated__/GetVendorsWithInvoicePreview';

export type {
  GetVendors,
  GetVendorsVariables,
  GetVendorsWithInvoicePreview,
  GetVendorsWithInvoicePreviewVariables,
};

export const GET_VENDORS = gql`
  query GetVendors($seasonId: String!, $marketDatesIn: [String!]) {
    myAccount {
      id
      name
      currentSeason {
        id
      }
      settings {
        currency
      }
      seasons {
        id
        createdAt
      }
    }
    season(id: $seasonId) {
      id
      signupForm {
        fields {
          id
          type
          definition
        }
      }
      markets {
        id
        name
        dates
      }
      vendors(marketDatesIn: $marketDatesIn) {
        id
        name
        contact
        email
        category
        status
        balance
        tags {
          id
        }
        markets {
          id
          dates
        }
        createdAt
      }
      tags {
        id
        name
        color
      }
      vendorCategories
    }
  }
`;

export const GET_VENDORS_WITH_INVOICE_PREVIEW = gql`
  query GetVendorsWithInvoicePreview(
    $seasonId: String!
    $marketDatesIn: [String!]!
    $includeSalesData: Boolean!
  ) {
    myAccount {
      settings {
        currency
      }
    }
    season(id: $seasonId) {
      id
      signupForm {
        fields {
          id
          type
          definition
        }
      }
      vendors(marketDatesIn: $marketDatesIn) {
        id
        name
        contact
        email
        category
        status
        balance
        invoicePreview(
          selectedDates: $marketDatesIn
          includeSalesData: $includeSalesData
        ) {
          taxPercent
          totalPrice
        }
        tags {
          id
        }
        markets {
          id
          dates
        }
        createdAt
      }
      tags {
        id
        name
        color
      }
      vendorCategories
    }
  }
`;
